import { ServiceDeliveryChartsState } from '@pages/executive-reports-old/components/executive-reports-tabs/service-delivery-report/store/states/service-delivery-charts.state';
import { SelectedModuleSubOrganizationsState } from '@pages/executive-reports-old/components/executive-reports-tabs/service-delivery-report/store/states/selected-module-sub-organizations.state';

export const serviceDeliveryStates = [ServiceDeliveryChartsState, SelectedModuleSubOrganizationsState];
